import { render, staticRenderFns } from "./Prompt.vue?vue&type=template&id=1998c19c&scoped=true"
import script from "./Prompt.vue?vue&type=script&lang=js"
export * from "./Prompt.vue?vue&type=script&lang=js"
import style0 from "./Prompt.vue?vue&type=style&index=0&id=1998c19c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1998c19c",
  null
  
)

export default component.exports